import React from 'react';
import { Box, Container, Group, Text } from '@mantine/core';

/**
 * Footer — MineMiner SPA footer.
 *
 * sprint-104 (epic-013 Sprint B, step 2d / S5). Slimmed from `Frontend/`'s
 * Footer:
 *
 *   - No Privacy / Terms links (the MineMiner SPA has no legal pages yet).
 *   - No reCAPTCHA attribution (the MineMiner SPA has no reCAPTCHA surface).
 *   - Brand-line text updated for the MineMiner spinout.
 */
export const Footer: React.FC = (): React.ReactElement => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      py={{ base: 'sm', sm: 'md' }}
      mt="auto"
      // eslint-disable-next-line react/forbid-component-props -- footer top-border + gray bg-tint need raw CSS vars; Mantine has no style-prop for a single-side border
      style={{
        borderTop: '1px solid var(--mantine-color-gray-3)',
        backgroundColor: 'var(--mantine-color-gray-0)',
      }}
    >
      <Container size="xl">
        <Group justify="center">
          <Text size="xs" c="dimmed">
            &copy; {currentYear} MineMiner. All rights reserved.
          </Text>
        </Group>
      </Container>
    </Box>
  );
};
